
import { Component, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MainTabsService } from '../../services/main-tabs/main-tabs.service';
import { CustomerContributionComponent } from '../customer-contribution/customer-contribution.component';
import { CollateralObjectsComponent } from '../collateral-objects/collateral-objects.component';
import { PoTreeviewComponent } from '../po-treeview/po-treeview.component';
import { ToasterService } from '../../toaster-module/toaster-service/toaster.service';
import { HttpClient } from "@angular/common/http";
import { MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, take, takeUntil } from 'rxjs/operators';
import {CivMainService} from "./civ-main.service";
import {ProductOverviewRequest} from "../../services/product-overview/product-overview-request.model";

const BUSYCURSOR = 'busy-cursor';
const CHRONOS_FALLBACK_URL = 'https://chronos-prod.azurewebsites.net/Deeplinks/CustomerDetails?customerIds=';

@Component({
  selector: 'app-civ-main',
  templateUrl: './civ-main.component.html',
  styleUrls: ['./civ-main.component.css'],
})
export class CivMainComponent implements OnDestroy {

  @ViewChild(CustomerContributionComponent) customerContribution;
  @ViewChild(CollateralObjectsComponent) collateralObjects;
  @ViewChild(PoTreeviewComponent, { static: false }) productoverview;

  npPerspective: boolean;
  perspective: 'NP' | 'ORG' | undefined;
  showProductOverview: boolean;
  showCollateralObject: boolean;
  showCustomerContribution: boolean;
  data: any;
  showError: boolean;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private service: MainTabsService,
    private toasterService: ToasterService,
    private civMainService: CivMainService,
    private http: HttpClient,
    private msalBroadcast: MsalBroadcastService,
  ) {
    this.data = {
      products: 'Producten',
      collateralObjects: 'Registergoederen',
      customerContribution: 'Klantbijdrage',
      financingView: 'Financieringsbeeld',
    };
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params: any) => {
      if (params['orgYN']) {
        if (params['error']) {
          this.showError = true;
        } else {
          if (params['orgYN'] === 'N') {
            this.npPerspective = true;
            this.perspective = 'NP';
          } else if (params['orgYN'] === 'Y') {
            this.npPerspective = false;
            this.perspective = 'ORG';
          }
          this.showCollateralObject = false;
          this.showCustomerContribution = false;
        }
      }
      this.showProductOverview = true;

    });
  }

  ngAfterViewInit() {
    if (this.showError) {
      this.toasterService.startWideErrorToast([
        'De request parameters waren niet correct.',
        'Meld een incident bij de Cross Channel Service Desk.'
      ], null, false);
      return;
    }

    this.msalBroadcast.inProgress$
      .pipe(
        filter((status) => status === InteractionStatus.None),
        take(1),
        takeUntil(this.destroy$),
      )
      .subscribe(() => {
        this.route.queryParams.subscribe(params => {
          const listOfCustomerId = params['listOfCustomerId'];
          const parentCustomerId = params['parentCustomerId'];
          const contactMomentId = params['contactMomentId'];
          ProductOverviewRequest.orgYN = params['orgYN'];
          this.civMainService
            .getTokensFromBackend(listOfCustomerId, parentCustomerId, contactMomentId)
            .subscribe((resp: any) => {
              ProductOverviewRequest.parametersToken = resp.parametersToken;
              this.productoverview?.loadProductoverview();
            });
        });

      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  openProductOverview() {
    this.showCollateralObject = false;
    this.showCustomerContribution = false;
    this.showProductOverview = true;
  }

  openCollateralObjects() {
    this.addBusyCursor();
    this.showProductOverview = false;
    this.showCustomerContribution = false;
    this.collateralObjects.loadCollateralObjects();
    this.showCollateralObject = true;
  }

  openCustomerContribution() {
    this.addBusyCursor();
    this.getChronosURL();
    this.showProductOverview = true;
    this.showCollateralObject = false;
    this.showCustomerContribution = false;
  }

  openFinancingView() {
    this.addBusyCursor();
    this.service.getParameters().subscribe(
      (resp) => {
        this.service.openFinancingView(resp.parentCustomerId, resp.bankCode);
        this.removeBusyCursor();
      },
      (error) => {
        this.removeBusyCursor();
        this.toasterService.startErrorToast(
          [error.error.ListOfInfo[0].description + 'financieringsbeeld.'],
          '',
          true
        );
      },
    );
  }

  getChronosURL() {
    this.addBusyCursor();
    this.service.getChronosURLAPICall().subscribe(
      (resp: any) => {
        const url = resp.url;
        window.open(url, '_blank');
        this.removeBusyCursor();
      },
      () => {
        window.open(CHRONOS_FALLBACK_URL, '_blank');
        this.removeBusyCursor();
      },
    );
  }

  addBusyCursor() {
    document.body.classList.add(BUSYCURSOR);
  }

  removeBusyCursor() {
    document.body.classList.remove(BUSYCURSOR);
  }
}
